import { render, staticRenderFns } from "./PartOfVehicles.vue?vue&type=template&id=569f0ecd&"
import script from "./PartOfVehicles.vue?vue&type=script&lang=js&"
export * from "./PartOfVehicles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports